import { EnvType } from "../services";
import ApiClient from "../api-client";
import ISearchApiClient from "./search-api-client";
import SearchApiClient from "./search-api-client";
import { SearchAdvancedRequest } from "../Types/search-advanced-request";
import { SearchAdvancedResponse } from "../Types/search-advanced-response";
import { SearchResponse } from "../Types/search-response";
import { SearchRequestNative } from "../Types/search-request-native";
import { ObjectLayer } from "../Types/object-layer";
import { ObjectType } from "../Types/object-type";
import { DbAssetObjectInfos } from "../Types/db-asset-object-infos";
import { ObjectStatus } from "../Types/object-status";
import { Distinct } from "../../../Utils/helpers";
import {
  IngestApprovedProps,
  IngestApprovedRows,
} from "../../../Pages/admin/Ingest/IngestIndex/IngestApproved/ingest-approved";
import { GenericSearchWithParametersRequest } from "../Types/generic-search-with-parameters-request";
import { GetItemsListResponse } from "../Types/get-items-list-response";

export default class SearchService {
  searchApiClient: ISearchApiClient;

  constructor(envType: EnvType) {
    this.searchApiClient = new SearchApiClient(new ApiClient(envType), envType);
  }

  async SearchWithParameters(request: GenericSearchWithParametersRequest): Promise<GetItemsListResponse> {
    return await this.searchApiClient.SearchWithParameters(request);
  }

  async SearchBasic(request: SearchRequestNative, abortSignal?: AbortSignal): Promise<SearchResponse> {
    return await this.searchApiClient.SearchBasic(request, abortSignal);
  }

  async SearchAdvanced(request: SearchAdvancedRequest): Promise<SearchAdvancedResponse> {
    return await this.searchApiClient.SearchAdvanced(request);
  }

  async CreateShareSearch(isAsset: boolean | null, pattern: string | null): Promise<SearchResponse> {
    let request = new SearchRequestNative({
      outputLayer: isAsset ? ObjectLayer.Asset : ObjectLayer.Title,
      hideTitleWithoutAsset: false,
      pattern: pattern,
      types: isAsset ? [ObjectType.Audio, ObjectType.AudioClip, ObjectType.Video, ObjectType.VideoClip] : null,
    });
    return await this.searchApiClient.SearchBasic(request);
  }

  async SearchBasicNativeByStatusesIngest(statuses: ObjectStatus[]): Promise<IngestApprovedProps | null> {
    const request: SearchRequestNative = new SearchRequestNative({
      hideTitleWithoutAsset: false,
      outputLayer: ObjectLayer.Asset,
      statuses: statuses,
      limit: 5,
    });
    const instances = (await this.searchApiClient.SearchBasic(request)).results;

    if (instances) {
      const computedInstances = this.MapInstanceInfosToIngestApprovedRows(instances);

      const data: IngestApprovedProps = {
        rows: computedInstances,
        filtersData: {
          type: computedInstances
            .map((x) => x.assetType)
            .filter(Distinct)
            .sort(),
          class: computedInstances
            .map((x) => x.assetClass)
            .filter(Distinct)
            .sort(),
        },
      };
      return data;
    }
    return null;
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.searchApiClient.GetApiUrl();
  }

  //------Private------
  private MapInstanceInfosToIngestApprovedRows(instancesInfos: DbAssetObjectInfos[]): IngestApprovedRows[] {
    if (instancesInfos === null || instancesInfos.length === 0) return [];

    let mappedData: IngestApprovedRows[] = [];

    instancesInfos.forEach((instance) => {
      mappedData.push({
        assetName: instance.name || "",
        assetType: instance.type,
        createdByUserName: instance.creationInfos?.userName || "",
        id: instance.id,
        createdAt: instance.creationInfos?.date.toString() || "-",
        providerName: instance.providerName || "",
        assetId: instance.id,
        assetClass: instance.classification,
        message: instance.statusHistory?.at(-1)?.comment || null,
      });
    });

    return mappedData;
  }
}
